// $(document).ready(function () {
//           const flagIcons = {
//       "FR": '<i class="ly-icon ly-flag-icon ly-flag-icon-fr"></i>',
//       "IT": '<i class="ly-icon ly-flag-icon ly-flag-icon-it"></i>',
//       "ES": '<i class="ly-icon ly-flag-icon ly-flag-icon-es"></i>',
//       "NL": '<i class="ly-icon ly-flag-icon ly-flag-icon-nl"></i>',
//       "DE": '<i class="ly-icon ly-flag-icon ly-flag-icon-de"></i>',
//       "SK": '<img src="https://cdn.shopify.com/s/files/1/0648/7877/2313/files/ly_flag_of_europe_svg_1754672921.webp?v=1754672928" alt="EU" class="ly-icon ly-flag-icon ly-flag-icon-eu">',
//       "UK": '<img src="https://app.gelacy.app/flags/gb.svg" alt="gb" class="ly-icon ly-flag-icon ly-flag-icon-uk">'
//     };
//    const updateSelectedFlag = () => {
//     const $switcher = $('.ly-country-switcher');
//     const $selectedLi = $switcher.find('li.current, li[aria-selected="true"]').first();
//     const $currentDisplay = $switcher.find('.ly-custom-dropdown-current-inner');

//     if (!$selectedLi.length || !$currentDisplay.length) return;

//     let countryCode = $selectedLi.attr('key') || $selectedLi.find('a').data('country-code');
//     if (!countryCode) return;

//     countryCode = countryCode.replace('-EUR', '').toUpperCase();
//     let countryName = $selectedLi.find('.ly-inner-text').text().trim();

//     // Rename SK to Rest of Europe
//     if (countryCode === 'SK') countryName = 'Rest of Europe';

//     // Clear existing flag icons before adding new
//     $currentDisplay.find('.ly-icon, i.ly-flag-icon, img.ly-flag-icon').remove();

//     // Add matching flag if exists
//     if (flagIcons[countryCode]) {
//       $currentDisplay.prepend(flagIcons[countryCode] + ' ');
//     }
//     // Update visible text
//     $currentDisplay.text(countryName);
//   };

//   const addUK = setInterval(function () {
//     const $countrySwitcher = $('.ly-country-switcher');
//     const $languageSwitcher = $('.ly-languages-switcher');
//     const $dropdown_lang = $('.ly-languages-switcher ul.ly-custom-dropdown-list');
//     const $dropdown_con = $('.ly-country-switcher ul.ly-custom-dropdown-list');

//     //Allowed countries
//     const allowedCountries = ['DE', 'NL', 'ES', 'FR', 'IT', 'UK', 'SK'];

//     //1. Collect icons from language dropdown
//     // let flagIcons = {};
//     if ($dropdown_lang.length) {
//       $dropdown_lang.find('li').each(function () {
//         const key = $(this).attr('key')?.toUpperCase();
//         const $img = $(this).find('i.ly-icon.ly-flag-icon').remove();
//         // if (key && $img.length) {
//         //   flagIcons[key] = $img.prop('outerHTML'); // store the <img> HTML
//         // }
//       });
//     }
    
//     // console.log(flagIcons);
//     //2. Add UK in language dropdown if missing
//     // if ($dropdown_lang.length && !$dropdown_lang.find('li[key="uk"]').length) {
//     //   const html_lang = `
//     //     <li key="uk" style="color: #000; margin: 0; padding: 0;" tabindex="-1">
//     //       <a class="ly-custom-dropdown-list-element ly-languages-switcher-link ly-bright-theme"
//     //          href="https://ezydog.co.uk/" target="_blank" rel="nofollow">
//     //         <img src="https://app.gelacy.app/flags/gb.svg" alt="gb" class="ly-icon ly-flag-icon ly-flag-icon-uk">
//     //         <span class="ly-custom-dropdown-list-element-right">United Kingdom</span>
//     //       </a>
//     //     </li>
//     //   `;
//     //   $dropdown_lang.append(html_lang);
//     //   flagIcons['UK'] = `<img src="https://app.gelacy.app/flags/gb.svg" alt="gb" class="ly-icon ly-flag-icon ly-flag-icon-uk">`;
//     // }



//     $(".ly-custom-dropdown-current").find(".ly-flag-icon").remove();


//   // Run on load and after dropdown change
//   updateSelectedFlag();
//     //3. Clean up country dropdown & update flags
//     if ($dropdown_con.length) {
//       $dropdown_con.find('li').each(function () {
//         const key = $(this).attr('key');
//         const iso = key ? key.replace('-EUR', '').toUpperCase() : '';

//         if (iso && !allowedCountries.includes(iso)) {
//           $(this).remove(); // remove disallowed
//         } else if (iso === 'SK') {
//           // rename SK to Rest of Europe
//           $(this)
//             .find('.ly-inner-text, .ly-custom-dropdown-list-element-right')
//             .text('Rest of Europe');
//         }

//         // replace image with flag from language dropdown
//         if (flagIcons[iso]) {
//           const $img = $(this).find('.ly-custom-dropdown-list-element');
//           if ($img.length) {
//             $img.prepend(flagIcons[iso]);
//           }
//         }
//       });
//     }

//     //4. Add UK to country dropdown if missing
//     if ($dropdown_con.length && !$dropdown_con.find('li[key="uk"]').length) {
//       const html_con = `
//         <li key="uk" style="color: #000; margin: 0; padding: 0;" tabindex="-1">
//           <a class="ly-custom-dropdown-list-element ly-languages-switcher-link ly-bright-theme"
//              href="https://ezydog.co.uk/" target="_blank" rel="nofollow">
//             ${flagIcons['UK'] || '<img src="https://app.gelacy.app/flags/gb.svg" alt="gb" class="ly-icon ly-flag-icon ly-flag-icon-uk">'}
//             <span class="ly-custom-dropdown-list-element-right">United Kingdom</span>
//           </a>
//         </li>
//       `;
//       $dropdown_con.append(html_con);
//     }

//     // --- Add a Globe icon before the country switcher (only once) ---
//     if (!$countrySwitcher.prev('.ly-country-icon').length) {
//       $countrySwitcher.before(`
//         <span class="ly-country-icon" style="display:inline-flex;align-items:center;margin-right:6px;">
//          <svg fill="#000000" width="18px" height="18px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M32.032 16c0-8.501-6.677-15.472-15.072-15.969-0.173-0.019-0.346-0.032-0.523-0.032-0.052 0-0.104 0.005-0.156 0.007-0.093-0.002-0.186-0.007-0.281-0.007-8.84 0-16.032 7.178-16.032 16.001s7.192 16.001 16.032 16.001c0.094 0 0.188-0.006 0.281-0.008 0.052 0.002 0.104 0.008 0.156 0.008 0.176 0 0.349-0.012 0.523-0.032 8.395-0.497 15.072-7.468 15.072-15.969zM29.049 21.151c-0.551-0.16-1.935-0.507-4.377-0.794 0.202-1.381 0.313-2.84 0.313-4.357 0-1.196-0.069-2.354-0.197-3.469 3.094-0.37 4.45-0.835 4.54-0.867l-0.372-1.050c0.695 1.659 1.080 3.478 1.080 5.386 0 1.818-0.352 3.555-0.987 5.151zM8.921 16c0-1.119 0.074-2.212 0.21-3.263 1.621 0.127 3.561 0.222 5.839 0.243v6.939c-2.219 0.021-4.114 0.111-5.709 0.234-0.22-1.319-0.34-2.715-0.34-4.154zM16.967 2.132c2.452 0.711 4.552 4.115 5.492 8.628-1.512 0.12-3.332 0.209-5.492 0.229v-8.857zM14.971 2.156v8.832c-2.136-0.021-3.965-0.109-5.502-0.226 0.96-4.457 3.076-7.836 5.502-8.606zM14.971 21.913l0 7.929c-2.263-0.718-4.256-3.705-5.293-7.719 1.492-0.11 3.253-0.189 5.292-0.21zM16.967 29.868l-0-7.955c2.061 0.020 3.814 0.102 5.288 0.217-1.019 4.067-3 7.076-5.288 7.738zM16.967 19.92l0-6.939c2.291-0.021 4.218-0.118 5.818-0.25 0.131 1.053 0.203 2.147 0.203 3.268 0 1.442-0.116 2.84-0.329 4.16-1.575-0.128-3.462-0.219-5.692-0.24zM28.588 9.81c-0.302 0.094-1.564 0.453-4.094 0.751-0.564-2.998-1.584-5.561-2.91-7.412 3.048 1.325 5.535 3.697 7.005 6.661zM11.213 2.831c-1.632 1.873-2.963 4.568-3.691 7.754-2.265-0.245-3.623-0.534-4.166-0.665 1.585-3.27 4.407-5.836 7.856-7.088zM2.614 11.787c0.385 0.104 1.841 0.467 4.549 0.766-0.155 1.107-0.24 2.26-0.24 3.447 0 1.509 0.136 2.96 0.383 4.334-2.325 0.251-3.755 0.552-4.396 0.706-0.607-1.566-0.944-3.264-0.944-5.041 0-1.467 0.228-2.883 0.649-4.213zM3.784 22.886c0.727-0.154 2.029-0.39 3.956-0.591 0.759 2.803 1.993 5.175 3.473 6.874-3.16-1.148-5.79-3.398-7.429-6.282v0zM21.583 28.849c1.195-1.665 2.14-3.907 2.728-6.525 1.982 0.227 3.226 0.494 3.853 0.652-1.5 2.596-3.808 4.669-6.581 5.873z"></path> </g></svg>
//         </span>
//       `);
//     }
//      // --- Add a Language icon before the language switcher (only once) ---
//     if (!$languageSwitcher.prev('.ly-language-icon').length) {
//       $languageSwitcher.before(`
//         <span class="ly-language-icon" style="display:inline-flex;align-items:center;margin:0 6px; 0 12px">
//           <svg width="18px" height="18px" viewBox="0 0 48 48" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style> .cls-1 { fill: none; stroke:#000000; stroke-linecap: round; stroke-linejoin: round; } </style> </defs> <line class="cls-1" x1="12.62" y1="24.31" x2="17.94" y2="11.42"></line> <line class="cls-1" x1="23.04" y1="24.35" x2="17.94" y2="11.42"></line> <line class="cls-1" x1="21.34" y1="20.02" x2="14.39" y2="20.02"></line> <g> <line class="cls-1" x1="32.63" y1="25.38" x2="39.35" y2="25.38"></line> <path class="cls-1" d="M35.68,25.38c0,4.34-5.29,11.51-10.59,12.61"></path> <path class="cls-1" d="M27.93,32.79c2.13,2.4,5.61,4.74,8.82,5.2"></path> </g> <rect class="cls-1" x="5.5" y="5.5" width="24.67" height="24.67" rx="3.64" ry="3.64"></rect> <path class="cls-1" d="M17.83,30.17v8.69c0,2,1.64,3.64,3.64,3.64h17.38c2,0,3.64-1.64,3.64-3.64V21.47c0-2-1.64-3.64-3.64-3.64h-8.69"></path> </g></svg>
//         </span>
//       `);
//     }


//     clearInterval(addUK);
//   }, 200);
// });

$(document).ready(function () {

const addUK = setInterval(function () {

 const $dropdown_lag = $('.ly-languages-switcher ul.ly-custom-dropdown-list');
  if ($dropdown_lag.length && !$dropdown_lag.find('li[key="uk"]').length) {
   const html_lag = `<li key="uk" style="color: #000; margin: 0;  padding: 0; " tabindex="-1"> <a class="ly-custom-dropdown-list-element ly-languages-switcher-link ly-bright-theme" href="https://ezydog.co.uk/" target="_blank" rel="nofollow"> <img src="https://app.gelacy.app/flags/gb.svg" alt="gb" class="ly-icon ly-flag-icon ly-flag-icon-uk"> <span class="ly-custom-dropdown-list-element-right">United Kingdom</span> </a> </li>` ;
  $dropdown_lag.append(html_lag);
  } const $dropdown_con = $('.ly-country-switcher ul.ly-custom-dropdown-list');
  if ($dropdown_con.length && !$dropdown_con.find('li[key="uk"]').length) {
   const html_con = `<li key="uk" style="color: #000;  margin: 0;  padding: 0; " tabindex="-1"> <a class="ly-custom-dropdown-list-element ly-languages-switcher-link ly-bright-theme" href="https://ezydog.co.uk/" target="_blank" rel="nofollow"> <img src="https://app.gelacy.app/flags/gb.svg" alt="gb" class="ly-icon ly-flag-icon ly-flag-icon-uk"> <span class="ly-custom-dropdown-list-element-right">United Kingdom</span> </a> </li>` ;
  $dropdown_con.append(html_con);
  clearInterval(addUK);
  } }, 100);
  });



if (window.location.pathname.includes("/collections/")) {
  const pathSegments = window.location.pathname.split('/');
  const collectionHandle = pathSegments[pathSegments.length - 1] || pathSegments[pathSegments.length - 2]; // in case the URL ends with a '/'
  sessionStorage.setItem('lastCollection', collectionHandle);
  console.log(sessionStorage.getItem('lastCollection'));
} else {
  if (!window.location.pathname.includes("/products/")) {
    // console.log("not on collection page");
    sessionStorage.removeItem('lastCollection');
  }
}

document.addEventListener("DOMContentLoaded", function() {
  var linksWithDataAttribute = document.querySelectorAll('[data-url]');
// console.log("linksWithDataAttribute", linksWithDataAttribute)
  linksWithDataAttribute.forEach(function(link) {
    link.addEventListener("click", function(e) {
      e.preventDefault(); // Prevent the default link behavior

      var dataFollowLink = link.getAttribute("data-url");

      if (dataFollowLink) {
        window.location.href = dataFollowLink; // Navigate to the data URL
      }
    });
  });
});

$(document).on('product:added product:removed', function() {
  $('.free-shipping-remaining-text').text('New Shipping Text');
});

// Quick add to cart
function addProductToCart(id, productId){
  const formData = {
    id: id,
    quantity: 1
  };

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(formData),
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json'
    },
    beforeSend: function(){
      buttonLoading(productId)
    },
    success: function(cart) {
      buttonStopLoading(productId)
      
      $.getJSON('/cart.js', function(updatedCart) {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: {
            cart: updatedCart
          }
        }));
      });        
        
      const cartDrawerElement = document.querySelector('#cart-drawer');
      if (cartDrawerElement) {
        cartDrawerElement.show();
      } 
        
    },
    error: function(errorThrown) {
      buttonStopLoading(productId)

        var r = jQuery.parseJSON(errorThrown.responseText);
        $(".error_" + pro_id).html("Error: " + r.description).show();
        setTimeout(function() {
            $(".error_" + pro_id).html("").hide(100);
        }, 3000);
      }
  });
  
}

function buttonLoading(productId){
  $(`.loading-${productId}`).removeClass('noopacity');
  $(`.add-text-${productId}`).addClass('noopacity');
  $(`.button-${productId}`).prop('disabled', true);
  $(`.button-${productId}`).addClass('button-disabled');
}
function buttonStopLoading(productId){
  $(`.loading-${productId}`).addClass('noopacity');
  $(`.add-text-${productId}`).removeClass('noopacity');
  $(`.button-${productId}`).prop('disabled', false);
  $(`.button-${productId}`).removeClass('button-disabled');
}

CONVERT_HARNESS_MAPPING = {
  "2XS": { patch: "100mm", d_ring: "25mm" },
  "XS": { patch: "100mm", d_ring: "25mm" },
  "S": { patch: "130mm", d_ring: "38mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "158mm", d_ring: "50mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

EXPRESS_HARNESS_MAPPING = {
  "2XS": { patch: "100mm", d_ring: "25mm" },
  "XS": { patch: "100mm", d_ring: "25mm" },
  "S": { patch: "100mm", d_ring: "25mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "130mm", d_ring: "38mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

SADDLE_BAGS_MAPPING = {
  "S": { patch: "110mm", d_ring: "25mm" },
  "L": { patch: "155mm", d_ring: "50mm" }
}

BACK_PACK_MAPPING = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "110mm", d_ring: "" }
}

ORTHO_SMART_BED_MAPPING = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "130mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_LOUNGER_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_CALM_ELITE_BED_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

FORMFIT_MAPPING = {
  "2XS": { patch: "60mm", d_ring: "" },
  "XS": { patch: "60mm", d_ring: "" },
  "S": { patch: "75mm", d_ring: "" },
  "M": { patch: "75mm", d_ring: "" },
  "L": { patch: "95mm", d_ring: "" },
  "XL": { patch: "95mm", d_ring: "" }
}

// Product IDS will be set under ids (convert harness will require getting all the convert harness ids for instance)
// Mapping from product size to patch/dring etc will be set up above

window.mapping = [
  {
    product: "Convert harness",
    ids: [7975152353369, 7975151206489, 7975149142105, 7975151763545],
    mapping: CONVERT_HARNESS_MAPPING
  },
  {
    product: "Express harness",
    ids: [7975149371481, 7975152386137, 7975151894617, 7975151370329],
    mapping: EXPRESS_HARNESS_MAPPING
  },
  {
    product: "Saddle bags",
     ids: [7975147798617],
    mapping: SADDLE_BAGS_MAPPING
  },
  {
    product: "Back pack",
    ids: [7975147831385],
    mapping: BACK_PACK_MAPPING
  },
  {
    product: "Ortho smart bed",
     ids: [7975153991769],
    mapping: ORTHO_SMART_BED_MAPPING
  },
  {
    product: "Ortho lounger",
    ids: [7975154057305],
    mapping: ORTHO_LOUNGER_MAPPING
  },
  {
    product: "Elite smart bed",
    ids: [7975154024537],
    mapping: ORTHO_CALM_ELITE_BED_MAPPING
  },
  {
    product: "Formfit",
    ids: [7975154581593],
    mapping: FORMFIT_MAPPING
  }, 
  
]

/* new label customizations mappings by sudh */
CONVERT_HARNESS_MAPPING_NEW = {
 "S": { patch: "130mm", d_ring: "38mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "158mm", d_ring: "50mm" },
  "XXL": { patch: "158mm", d_ring: "50mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

EXPRESS_HARNESS_MAPPING_NEW = {
  "2XS": { patch: "100mm", d_ring: "25mm" },
  "XS": { patch: "100mm", d_ring: "25mm" },
  "S": { patch: "100mm", d_ring: "25mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "130mm", d_ring: "38mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

SADDLE_BAGS_MAPPING_NEW = {
  "S": { patch: "110mm", d_ring: "25mm" },
  "L": { patch: "158mm", d_ring: "50mm" }
}

BACK_PACK_MAPPING_NEW = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "110mm", d_ring: "" }
}
ORTHO_SMART_BED_MAPPING_NEW = {
  "S": { patch: "100mm", d_ring: "" },//110mm
  "M": { patch: "130mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_LOUNGER_MAPPING_NEW = {
  "M": { patch: "100mm", d_ring: "" },//110mm
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_CALM_ELITE_BED_MAPPING_NEW = {
  "M": { patch: "100mm", d_ring: "" },//110mm
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

// // FORMFIT_MAPPING_NEW = {
//   "2XS": { patch: "60mm", d_ring: "" },
//   "XS": { patch: "60mm", d_ring: "" },
//   "S": { patch: "75mm", d_ring: "" },
//   "M": { patch: "75mm", d_ring: "" },
//   "L": { patch: "95mm", d_ring: "" },
//   "XXL": { patch: "95mm", d_ring: "" },
//   "2XL": { patch: "95mm", d_ring: "" },
//   "XL": { patch: "95mm", d_ring: "" }
// }

FORMFIT_MAPPING_NEW = {
  "2XS": { patch: "60mm", d_ring: "" },
  "XS": { patch: "60mm", d_ring: "" },
  "S": { patch: "75mm", d_ring: "" },
  "M": { patch: "75mm", d_ring: "" },
  "L": { patch: "95mm", d_ring: "" },
  "XL": { patch: "95mm", d_ring: "" }
}

window.mappingnew = [
  {
    product: "Convert harness",
    ids: [7975152353369, 7975151206489, 7975149142105, 7975151763545],
    mappingnew: CONVERT_HARNESS_MAPPING_NEW
  },
  {
    product: "Express harness",
    ids: [7975149371481, 7975152386137, 7975151894617, 7975151370329],
    mappingnew: EXPRESS_HARNESS_MAPPING_NEW
  },
  {
    product: "Saddle bags",
    ids: [7975147798617],
    mappingnew: SADDLE_BAGS_MAPPING_NEW
  },
  {
    product: "Back pack",
    ids: [7975147831385],
    mappingnew: BACK_PACK_MAPPING_NEW
  },
  {
    product: "Ortho smart bed",
    ids: [7975153991769],
    mappingnew: ORTHO_SMART_BED_MAPPING_NEW
  },
  {
    product: "Ortho lounger",
    ids: [7975154057305],
    mappingnew: ORTHO_LOUNGER_MAPPING_NEW
  },
  {
    product: "Elite smart bed",
    ids: [7975154024537],
    mappingnew: ORTHO_CALM_ELITE_BED_MAPPING_NEW
  },
  {
    product: "Formfit",
    ids: [7975154581593],
    mappingnew: FORMFIT_MAPPING_NEW
  }, 
  
]


let bedding_labels = ["Ortho smart bed", "Ortho lounger", "Elite smart bed"];
let formfit_labels = ["Formfit"];

window.bedding_mapping = window.mapping.filter(item => 
  bedding_labels.includes(item.product)
).map(item => item.ids).flat();

window.formfit_mapping = window.mapping.filter(item => 
  formfit_labels.includes(item.product)
).map(item => item.ids).flat();

function removeIcon(event) {
    const emojiRegex = /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FAFF}\u{1FB00}-\u{1FBFF}]/gu;
    
    const inputElement = $(event.target); // Access the input element
    const inputVal = inputElement.val();

    if (emojiRegex.test(inputVal)) {
        inputElement.val(inputVal.replace(emojiRegex, ''));
    }
}

$(document).on('input', '#cl-custom-text', removeIcon);
$(document).on('input', '#cl-custom-text_order', removeIcon);


























//   $(document).ready(function () {
    

//       const addUK = setInterval(function () {
//           const $countrySwitcher = $('.ly-country-switcher');
//     const $languageSwitcher = $('.ly-languages-switcher');
//     const $dropdown_lag = $('.ly-languages-switcher ul.ly-custom-dropdown-list');
//     if ($dropdown_lag.length && !$dropdown_lag.find('li[key="uk"]').length) {
//       const html_lag = `
//         <li key="uk" style="color: #000; margin: 0; padding: 0;" tabindex="-1">
//           <a class="ly-custom-dropdown-list-element ly-languages-switcher-link ly-bright-theme" 
//              href="https://ezydog.co.uk/" target="_blank" rel="nofollow">
//             <img src="https://app.gelacy.app/flags/gb.svg" alt="gb" class="ly-icon ly-flag-icon ly-flag-icon-uk">
//             <span class="ly-custom-dropdown-list-element-right">United Kingdom</span>
//           </a>
//         </li>
//       `;
//       $dropdown_lag.append(html_lag);
//     }
// const allowedCountries = ['DE', 'NL', 'ES', 'FR', 'IT', 'UK','SK'];
//     const $dropdown_con = $('.ly-country-switcher ul.ly-custom-dropdown-list');
//           // Remove all list items except the filter + allowed
//       $dropdown_con.find('li').each(function () {
//         const key = $(this).attr('key');
//         if (key && !allowedCountries.includes(key.replace('-EUR', '').toUpperCase())) {
//           $(this).remove();
//         }
//         console.log(key);
//         if (key && key =="SK-EUR") {
//            $(this)
//               .find('.ly-inner-text, .ly-custom-dropdown-list-element-right')
//               .text("Rest of Europe");
//         }
//       });

//       //  $dropdown_con.find('li').each(function () {
//       //   const key = $(this).attr('key');
//       //   if (key) {
//       //     const iso = key.replace('-EUR', '').toUpperCase();
//       //     if (allowedCountries.includes(iso)) {
//       //       $(this)
//       //         .find('.ly-inner-text, .ly-custom-dropdown-list-element-right')
//       //         .text(iso);
//       //     }
//       //   }
//       // });

//     if ($dropdown_con.length && !$dropdown_con.find('li[key="uk"]').length) {
//       const html_con = `
//         <li key="uk" style="color: #000; margin: 0; padding: 0;" tabindex="-1">
//           <a class="ly-custom-dropdown-list-element ly-languages-switcher-link ly-bright-theme" 
//              href="https://ezydog.co.uk/" target="_blank" rel="nofollow">
//             <span class="ly-custom-dropdown-list-element-right">United Kingdom</span>
//           </a>
//         </li>
//         `;
//         // <li key="SK-EUR" style=" padding: 0px 0px;" tabindex="-1">
//         //           <a class="ly-custom-dropdown-list-element" href="#" data-currency-code="EUR" data-country-code="SK" rel="nofollow">
//         //             <span class="ly-inner-text">Rest of Europe</span>
//         //           </a>
//         //         </li>
//       $dropdown_con.append(html_con);

//             // --- Add a Globe icon before the country switcher (only once) ---
//       if (!$countrySwitcher.prev('.ly-country-icon').length) {
//         $countrySwitcher.before(`
//           <span class="ly-country-icon" style="display:inline-flex;align-items:center;margin-right:6px;">
//            <svg fill="#000000" width="18px" height="18px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M32.032 16c0-8.501-6.677-15.472-15.072-15.969-0.173-0.019-0.346-0.032-0.523-0.032-0.052 0-0.104 0.005-0.156 0.007-0.093-0.002-0.186-0.007-0.281-0.007-8.84 0-16.032 7.178-16.032 16.001s7.192 16.001 16.032 16.001c0.094 0 0.188-0.006 0.281-0.008 0.052 0.002 0.104 0.008 0.156 0.008 0.176 0 0.349-0.012 0.523-0.032 8.395-0.497 15.072-7.468 15.072-15.969zM29.049 21.151c-0.551-0.16-1.935-0.507-4.377-0.794 0.202-1.381 0.313-2.84 0.313-4.357 0-1.196-0.069-2.354-0.197-3.469 3.094-0.37 4.45-0.835 4.54-0.867l-0.372-1.050c0.695 1.659 1.080 3.478 1.080 5.386 0 1.818-0.352 3.555-0.987 5.151zM8.921 16c0-1.119 0.074-2.212 0.21-3.263 1.621 0.127 3.561 0.222 5.839 0.243v6.939c-2.219 0.021-4.114 0.111-5.709 0.234-0.22-1.319-0.34-2.715-0.34-4.154zM16.967 2.132c2.452 0.711 4.552 4.115 5.492 8.628-1.512 0.12-3.332 0.209-5.492 0.229v-8.857zM14.971 2.156v8.832c-2.136-0.021-3.965-0.109-5.502-0.226 0.96-4.457 3.076-7.836 5.502-8.606zM14.971 21.913l0 7.929c-2.263-0.718-4.256-3.705-5.293-7.719 1.492-0.11 3.253-0.189 5.292-0.21zM16.967 29.868l-0-7.955c2.061 0.020 3.814 0.102 5.288 0.217-1.019 4.067-3 7.076-5.288 7.738zM16.967 19.92l0-6.939c2.291-0.021 4.218-0.118 5.818-0.25 0.131 1.053 0.203 2.147 0.203 3.268 0 1.442-0.116 2.84-0.329 4.16-1.575-0.128-3.462-0.219-5.692-0.24zM28.588 9.81c-0.302 0.094-1.564 0.453-4.094 0.751-0.564-2.998-1.584-5.561-2.91-7.412 3.048 1.325 5.535 3.697 7.005 6.661zM11.213 2.831c-1.632 1.873-2.963 4.568-3.691 7.754-2.265-0.245-3.623-0.534-4.166-0.665 1.585-3.27 4.407-5.836 7.856-7.088zM2.614 11.787c0.385 0.104 1.841 0.467 4.549 0.766-0.155 1.107-0.24 2.26-0.24 3.447 0 1.509 0.136 2.96 0.383 4.334-2.325 0.251-3.755 0.552-4.396 0.706-0.607-1.566-0.944-3.264-0.944-5.041 0-1.467 0.228-2.883 0.649-4.213zM3.784 22.886c0.727-0.154 2.029-0.39 3.956-0.591 0.759 2.803 1.993 5.175 3.473 6.874-3.16-1.148-5.79-3.398-7.429-6.282v0zM21.583 28.849c1.195-1.665 2.14-3.907 2.728-6.525 1.982 0.227 3.226 0.494 3.853 0.652-1.5 2.596-3.808 4.669-6.581 5.873z"></path> </g></svg>
//           </span>
//         `);
//       }

//        // --- Add a Language icon before the language switcher (only once) ---
//       if (!$languageSwitcher.prev('.ly-language-icon').length) {
//         $languageSwitcher.before(`
//           <span class="ly-language-icon" style="display:inline-flex;align-items:center;margin:0 6px; 0 12px">
//             <svg width="18px" height="18px" viewBox="0 0 48 48" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style> .cls-1 { fill: none; stroke:#000000; stroke-linecap: round; stroke-linejoin: round; } </style> </defs> <line class="cls-1" x1="12.62" y1="24.31" x2="17.94" y2="11.42"></line> <line class="cls-1" x1="23.04" y1="24.35" x2="17.94" y2="11.42"></line> <line class="cls-1" x1="21.34" y1="20.02" x2="14.39" y2="20.02"></line> <g> <line class="cls-1" x1="32.63" y1="25.38" x2="39.35" y2="25.38"></line> <path class="cls-1" d="M35.68,25.38c0,4.34-5.29,11.51-10.59,12.61"></path> <path class="cls-1" d="M27.93,32.79c2.13,2.4,5.61,4.74,8.82,5.2"></path> </g> <rect class="cls-1" x="5.5" y="5.5" width="24.67" height="24.67" rx="3.64" ry="3.64"></rect> <path class="cls-1" d="M17.83,30.17v8.69c0,2,1.64,3.64,3.64,3.64h17.38c2,0,3.64-1.64,3.64-3.64V21.47c0-2-1.64-3.64-3.64-3.64h-8.69"></path> </g></svg>
//           </span>
//         `);
//       }

//       clearInterval(addUK);
//     }
//   }, 100);
  
//   });